import React from 'react';

import Icon from 'kingpin/atoms/Icon';
import Typography from 'kingpin/atoms/Typography';
import Row from 'components/Common/Row';
import Tooltip from 'components/Tooltip';

const HIDDEN_DATASET_TOOLTIP =
  'This dataset is currently hidden from customers. Only staff members can see it.';

const HiddenDatasetLabel = ({
  label,
  typographyType = 'Label',
}: {
  label: string;
  typographyType?: 'Label' | 'Body 12';
}) => (
  <Row centerAlign style={{ gap: 6 }}>
    <Typography.Body type={typographyType} isEllipsis>
      {label}
    </Typography.Body>
    <Tooltip content={HIDDEN_DATASET_TOOLTIP}>
      <Icon
        icon="warning"
        color="var(--color-status-warning)"
        testId="hidden-dataset-warning"
      />
    </Tooltip>
  </Row>
);

export default HiddenDatasetLabel;
